import { List, SimpleList } from 'react-admin';

const QuestionList = () => (
    <List title={'Fragen'}>
        <SimpleList
        primaryText={(record) => record.frage}
        secondaryText={(record) => record.erklaerung}
        tertiaryText={(record) => record.kategorie}
        />
    </List>
    )

export default QuestionList;